import axios from 'axios'
import {
  baseURL
} from 'config'
import {
  takeLatest,
  fork,
  all,
  call,
  put,
} from 'redux-saga/effects'

import {
  jwtConfig,
  postRequest,
} from 'helpers/RequestUtil'

import {
  FETCH_TEST_CONFIG,
  FETCH_TEST_PROFILES,
  POST_TEST_CONFIG,
} from './constants'

import {
  fetchTestConfigStart,
  fetchTestConfigSuccess,
  fetchTestConfigError,
  startFetchTestConfigAsync,
  fetchTestProfilesStart,
  fetchTestProfilesSuccess,
  fetchTestProfilesError,
  startFetchTestProfilesAsync,
  postTestConfigStart,
  postTestConfigSuccess,
  postTestConfigError,
  startPostTestConfigAsync,
  updateTestConfigNames,
  updateTestList,
  updateTestProfiles,
} from './actions'

function* fetchTestConfig(sku) {
  try {
    yield put(startFetchTestConfigAsync())
    yield put(fetchTestConfigStart())
    const { data } = yield call(
      axios.get,
      `${baseURL}/api/fts/testConfig?sku=${sku}`,
      jwtConfig()
    )
    yield put(fetchTestConfigSuccess())
    return data
  } catch(error) {
    yield put(fetchTestConfigError(error))
  }
}

function* fetchTestProfiles(details) {
  const { segment, line, family } = details
  try {
    yield put(startFetchTestProfilesAsync())
    yield put(fetchTestProfilesStart())
    const query = `?segment=${segment}&line=${line}&family=${family}`
    const { data } = yield call(
      axios.get,
      `${baseURL}/api/fts/testProfiles${query}`,
      jwtConfig()
    )
    yield put(fetchTestProfilesSuccess())
    return data
  } catch(error) {
    yield put(fetchTestProfilesError(error))
  }
}

function* postTestConfig(details) {
  const { sku, segment, greenLightProfileName, nvqualProfileName } = details
  try {
    yield put(startPostTestConfigAsync())
    yield put(postTestConfigStart())
    const { data } = yield call(
      axios.post,
      `${baseURL}/api/fts/testConfig`,
      {
        sku,
        segment,
        greenLightProfileName,
        nvqualProfileName
      },
      jwtConfig()
    )
    yield put(postTestConfigSuccess())
    return data
  } catch (error) {
    yield put(postTestConfigError(error))
  }
}

function* handleFetchTestConfig(action) {
  const { sku } = action
  const testConfig = yield call(fetchTestConfig, sku)
  const { greenLightProfileName, nvqualProfileName, tests } = testConfig
  yield put(updateTestConfigNames({
    greenLightProfileName,
    nvqualProfileName
  }))
  yield put(updateTestList(tests))
}

function* handleFetchTestProfiles(action) {
  const { details } = action
  const testProfiles = yield call(fetchTestProfiles, details)
  yield put(updateTestProfiles(testProfiles))
}

function* handlePostTestConfig(action) {
  const { details } = action
  const { tests, testProfileNames } = yield call(postTestConfig, details)
  yield put(updateTestConfigNames(testProfileNames))
  yield put(updateTestList(tests))
}

function* watchFetchTestConfig() {
  yield takeLatest(FETCH_TEST_CONFIG, handleFetchTestConfig)
}

function* watchFetchTestProfiles() {
  yield takeLatest(FETCH_TEST_PROFILES, handleFetchTestProfiles)
}

function* watchPostTestConfig() {
  yield takeLatest(POST_TEST_CONFIG, handlePostTestConfig)
}

function* loadSagas() {
  yield all([
    fork(watchFetchTestConfig),
    fork(watchFetchTestProfiles),
    fork(watchPostTestConfig),
  ])
}

export default loadSagas